import { useSearchContext, useSearchQuery, useSearchArgs, buildDocumentEntityTypeFilter, } from 'app/domains/global-search';
export function useAllDocumentsSearchResults() {
    const { query, getMultiSelectFilterValue } = useSearchContext();
    const { getSearchWhereArgs } = useSearchArgs();
    return useSearchQuery({
        query,
        where: Object.assign(Object.assign({}, getSearchWhereArgs()), { entityType: buildDocumentEntityTypeFilter(getMultiSelectFilterValue('type')) }),
    });
}
